import { gql } from '@apollo/client';

export const CREATE_GUEST_TESTER_PROFILE = gql`
  mutation CreateGuestTesterProfile($guestTesterProfile: GuestTesterProfileAttributes!, $testSessionId: ID!) {
    createGuestTesterProfile(guestTesterProfile: $guestTesterProfile, testSessionId: $testSessionId) {
      guestTesterProfile {
                id
              }
    }
  }
`;

export const TEST_SESSION = gql`
  query TestSession($id: ID!) {
    testSession(id: $id) {
      id
      tester {
        user {
          tester
          guest
          id
        }
        segment {
          name
          audienceAttributes {
            audienceAttributeType,
            audienceAttributeOptions {
              id,
              value,
              name
            }
          }
        }
      }
    }
  }
 `;
